export default function cloneTemplate(
  templateSelector: string,
  context: Document | HTMLElement = document
) {
  const parentElement: Document | HTMLElement = context || document;
  const template =
    parentElement.querySelector<HTMLTemplateElement>(templateSelector);
  if (!template) return null;

  const fragment = template.content.cloneNode(true) as DocumentFragment;

  return fragment.firstElementChild as HTMLElement;
}
